export default __webpack_public_path__ + "static/media/Eye_5_F_C3.83fe388e.svg";